import React, { createContext, useContext, useMemo, ReactNode } from 'react';
import { useIsMutating } from '@tanstack/react-query';

export interface DataContextType {
  isProcessing: boolean;
  setIsProcessing: (val: boolean) => void;
}

const DataContext = createContext<DataContextType | undefined>(undefined);

interface DataProviderProps {
  children: ReactNode;
}

export const DataProvider: React.FC<DataProviderProps> = ({ children }) => {
  const [isProcessing, setIsProcessing] = React.useState(false);
  const isMutating = useIsMutating();

  const value = useMemo(() => ({
    isProcessing: isMutating > 0 || isProcessing,
    setIsProcessing,
  }), [isMutating, isProcessing]);

  return <DataContext.Provider value={value}>{children}</DataContext.Provider>;
};

export const useData = () => {
  const context = useContext(DataContext);
  if (context === undefined) {
    throw new Error('useData must be used within a DataProvider');
  }
  return context;
};
